import React from 'react';

import UserInfo from './UserInfo'

var rowStyle = {
  marginBottom: 5,
  paddingBottom: 5,
  borderBottom: '1px solid #ccc'
}

var resultStyle = {
  display: 'inline-block',
  verticalAlign: 'top',
  minHeight: 48,
  lineHeight: '48px',
  paddingLeft: 10,
}

export default ({result}) =>
  <div className="EoTResultRow" style={rowStyle}>
    <div style={{display: 'inline-block'}}>
      <UserInfo user={result.user} />
    </div>
    <div className="results" style={resultStyle}>
      {result.message}
    </div>
  </div>



// WEBPACK FOOTER //
// ./src/RollResults/MessageResult.js